<a
  (click)="onClearFilters()"
  matTooltip="Clear all filters"
  matTooltipPosition="above"
  i18n-matTooltip
  class="btn btn-outline-info"
  [class.filtering]="isFiltering"
>
  <i class="far fa-filter-circle-xmark"></i>
</a>
